import React, { useEffect, useState } from 'react';
import { Home } from './pages/home';
import { Widget, addResponseMessage, toggleWidget ,isWidgetOpened} from 'react-chat-widget';

import 'react-chat-widget/lib/styles.css';

import logo from './logo.svg';

function App() {
  // useEffect(() => {
  //   addResponseMessage('Welcome to this **awesome** chat!');
  //   addResponseMessage('Welcome to this **awesome** chat!');
  //   addResponseMessage('Welcome to this **awesome** chat!');
  //   // addResponseMessage('Welcome to this **awesome** chat!');
  //   addResponseMessage('Welcome to this **awesome** chat!');
  //   setInterval(() => {
  //     addResponseMessage('Welcome to this **awesome** chat!');
  //   }, 1000)
  // }, []);
  // const [a, seta] = useState(false)
  // // setTimeout(() => {

  // //   setInterval(() => {
  // //     seta(!a)
  // //     addResponseMessage('Welcome to this **awesome** chat!');
  // //   }, 1000)
  // // }, 2000);

  // const handleNewUserMessage = (newMessage: string) => {

  //   console.log(`New message incoming! ${newMessage}`);
  //   addResponseMessage(newMessage);
  //   addResponseMessage(newMessage);
  //   addResponseMessage(newMessage);
  //   // Now send the message throught the backend API
  // };

  // const getCustomLauncher = (handleToggle: any) =>
  //   <button onClick={() => {
  //     addResponseMessage('Welcome to this **awesome** chat!');
  //     handleToggle()
  //   }}>This is my launcher component!</button>

  //   useEffect(()=>{
  //     document.getElementsByClassName('rcw-widget-container')[0]?.addEventListener('click',()=>{
  //       requestAnimationFrame(()=>{
  //         console.log(isWidgetOpened())
  //       })
  //     },false);
  //   },[])
  // return (
  //   <div className="App">
  //     <Widget
  //     chatId="11111"
  //     handleToggle={()=>{alert()}}
  //     handleQuickButtonClicked={()=>{alert()}}
  //     showTimeStamp={true}
  //     launcherOpenLabel	="xxxx"
  //     launcherCloseLabel="123"
  //     // launcher={(handleToggle: any)=>getCustomLauncher(handleToggle)}
  //     onClick={()=>{alert()}}
  //     ></Widget>
  //   </div>
  // );
  return <Home></Home>
}

export default App;